
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const ProcessSection: React.FC = () => {
  return (
    <section className="section-padding bg-itmgmt-light-gray">
      <div className="container-wide">
        <div className="text-center mb-12">
          <h2 className="heading-lg text-itmgmt-dark-blue mb-4">Our Network Implementation Process</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We follow a systematic approach to ensure your network infrastructure meets your business needs.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">1</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Assessment</h3>
            <p className="text-gray-600">
              We evaluate your current infrastructure, business needs, and growth plans to understand requirements.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">2</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Design</h3>
            <p className="text-gray-600">
              We create a customized network architecture designed to meet your performance, security, and budget requirements.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">3</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Implementation</h3>
            <p className="text-gray-600">
              Our experts deploy and configure all network components with minimal disruption to your operations.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">4</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Management</h3>
            <p className="text-gray-600">
              We provide ongoing monitoring, maintenance, and support to ensure optimal network performance.
            </p>
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <Button asChild className="button-primary">
            <Link to="/book?service=network">Schedule a Network Assessment</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
